import { render, staticRenderFns } from "./UserLeave.vue?vue&type=template&id=2dcce491"
import script from "./UserLeave.vue?vue&type=script&lang=js"
export * from "./UserLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports